var AppDispatcher = require('../dispatcher/app-dispatcher');
var Constants = require('../constants/global');

var FavoritesServerActions = {

  added: function(placeId) {
    AppDispatcher.handleServerAction({
      actionType: Constants.RECEIVE_ADDED_FAVORITE,
      id: placeId
    });
  },

  removed: function(placeId) {
    AppDispatcher.handleServerAction({
      actionType: Constants.RECEIVE_REMOVED_FAVORITE,
      id: placeId
    });
  },

  receivedAll: function(placeIds) {
    AppDispatcher.handleServerAction({
      actionType: Constants.RECEIVE_ALL_FAVORITES,
      ids: placeIds
    });
  }
  
};

module.exports = FavoritesServerActions;



// WEBPACK FOOTER //
// ./actions/favorites-server-actions.js